import React from 'react';
import { Linkedin, Mail } from 'lucide-react';
import './AuthorBox.css';

const AuthorBox = ({ author }) => {
  if (!author) return null;

  return (
    <div className="author-box">
      <img 
        src={author.photo} 
        alt={author.name}
        className="author-box-photo"
      />
      <div className="author-box-content">
        <div className="author-box-header">
          <div>
            <h3 className="author-box-name">{author.name}</h3>
            <p className="author-box-title">{author.title}</p>
          </div>
          <div className="author-box-social">
            {author.linkedin && (
              <a 
                href={author.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="author-social-link"
              >
                <Linkedin size={20} />
              </a>
            )}
            {author.email && (
              <a 
                href={`mailto:${author.email}`}
                className="author-social-link"
              >
                <Mail size={20} />
              </a>
            )}
          </div>
        </div>
        <p className="author-box-bio">{author.bio}</p>
        {author.credentials && (
          <p className="author-box-credentials">{author.credentials}</p>
        )}
      </div>
    </div>
  );
};

export default AuthorBox;